// Storage key constant
export const PREFERRED_ORGANIZATION_ID_KEY = "preferredOrganizationId";

const TIMEZONE_CURRENCY_MAP: Record<string, string> = {
  "Asia/Kathmandu": "NPR",
  "Asia/Dubai": "AED",
};

export const getDefaultCurrencyFromTimezone = (timezone: string): string => {
  return TIMEZONE_CURRENCY_MAP[timezone] ?? "USD";
};

// Get saved organization preference
export const getPreferredOrganizationId = (): string | null => {
  try {
    return localStorage.getItem(PREFERRED_ORGANIZATION_ID_KEY);
  } catch (error) {
    console.error("Error reading organization preference:", error);

    return null;
  }
};

// Save organization preference
export const setPreferredOrganizationId = (organizationId: string): void => {
  try {
    localStorage.setItem(PREFERRED_ORGANIZATION_ID_KEY, organizationId);
  } catch (error) {
    console.error("Error saving organization preference:", error);
  }
};

// Clear organization preference
export const clearPreferredOrganizationId = (): void => {
  try {
    localStorage.removeItem(PREFERRED_ORGANIZATION_ID_KEY);
  } catch (error) {
    console.error("Error clearing organization preference:", error);
  }
};

// Get organization to activate on login (checks localStorage, validates membership)
export const getOrganizationToActivate = (
  organizationMemberships: Array<{ organization: { id: string } }>,
): string | null => {
  if (!organizationMemberships || organizationMemberships.length === 0) {
    return null;
  }

  const preferredId = getPreferredOrganizationId();

  // Validate saved preference against current memberships
  if (preferredId) {
    const hasAccess = organizationMemberships.some(
      (membership) => membership.organization.id === preferredId,
    );

    if (hasAccess) {
      return preferredId;
    }
    // Clear invalid preference (user was removed from org)
    clearPreferredOrganizationId();
  }

  // Fallback to first organization
  return organizationMemberships[0].organization.id;
};
